var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModulesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7011_9978)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7011_9978)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(2.5 2.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 14.0391V17.6784L21.7184 15.8033V12.1641L17.9688 14.0391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2188 20.6016V25.4993L17.031 23.8828V19.1953L14.2188 20.6016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 12.1641V15.8033L17.0309 17.6783V14.0391L13.2812 12.1641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7014 16.5625L10 17.9134L13.7496 19.7884L16.451 18.4375L12.7014 16.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 19.1953V23.8828L20.781 25.4993V20.6016L17.9688 19.1953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2964 16.5625L18.5469 18.4376L21.2483 19.7884L24.9978 17.9134L22.2964 16.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.7266V23.1243C9.5 23.3019 9.60024 23.4639 9.75907 23.5436L13.2496 25.4993V20.6016L9.5 18.7266Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 20.6016V25.4994L25.2405 23.5437C25.3994 23.464 25.4996 23.302 25.4996 23.1244V18.7266L21.75 20.6016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7092 9.54943C17.5774 9.48352 17.4218 9.48352 17.29 9.54943L13.75 11.3509L17.4996 13.2258L21.2491 11.3508L17.7092 9.54943Z",
    fill: "black"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 34.5,
    height: 34.5,
    stroke: "#E6E6E7",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7011_9978",
    x: 0.5,
    y: 2.5,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7011_9978"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.627451 0 0 0 0 0.698039 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7011_9978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7011_9978",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7011_9978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulesIcon);
export default __webpack_public_path__ + "static/media/modulesIcon.32ee7a6f9b2e765b8d5a039ebab2115c.svg";
export { ForwardRef as ReactComponent };